export default {
  tab: '피드백',
  toolbar: {
    markup: '마크업',
    record: '녹화',
    hint: '클릭하여 댓글, 드래그하여 그리기',
    hintTouch: '드래그해서 문제가 있는 곳을 표시하세요',
    hintRecord: '화면 녹화 중',
    exit: '나가기',
  },
  popup: {
    about: '정보',
    placeholder: '문제 또는 제안 사항을 설명해 주세요...',
    submit: '제출',
    sending: '전송 중...',
    cancel: '취소',
    close: '닫기',
    my_feedback: '내 피드백',
    screenshot_label: '스크린샷 첨부',
    screenshot_hint: '비밀번호 등 민감한 입력란은 자동으로 가려집니다.',
    screenshot_short: '스크린샷',
    screenshot_locked_hint: '그린 표시는 스크린샷 위에 합쳐지므로 항상 첨부됩니다. 민감한 입력란은 자동으로 가려집니다.',
    recording_label: '기록',
    recording_locked_hint: '페이지 화면과 조작 과정의 재현 기록으로, 항상 첨부됩니다. 카메라와 마이크는 포함되지 않으며 민감한 입력란은 자동으로 가려집니다.',
    quickOptions: [
      { emoji: '🐛', label: '오류', value: '문제가 있어요' },
      { emoji: '💡', label: '제안', value: '제안이 있어요' },
      { emoji: '🤔', label: '혼란', value: '헷갈려요' },
    ],
  },
  success: {
    title: '피드백이 접수되었습니다. 감사합니다.',
    title_no_ai: '감사합니다! 피드백을 접수했습니다.',
    close: '닫기',
    email_saved: '해결되면 이메일로 알려드립니다.',
    email_error: '이메일을 저장하지 못했습니다. 다시 시도해 주세요.',
    track_feedback: '처리 상황 보기',
    email_cta: '해결되면 이메일로 알림',
    notify: '알림',
  },
  error: {
    submit: '제출에 실패했습니다. 다시 시도해 주세요.',
    finalize_title: '아직 전송하지 못했습니다.',
    finalize_message: '피드백은 저장되어 있습니다. 다시 시도해 주세요.',
  },
  pet: {
    bubble: '도움이 필요하신가요?',
  },
  frustration: {
    prompt: '문제가 있으신가요? 알려 주세요.',
    action: '주석',
    dismiss: '닫기',
  },
  annotation: {
    drawing: '그리기',
    element: '요소',
  },
  draw: {
    note_placeholder: '그림에 메모 추가',
    undo: '실행 취소',
    redo: '다시 실행',
    cancel: '취소',
    submit: '보내기',
  },
  record: {
    stop: '중지',
    timer_label: '녹화 중',
    max_reached: '최대 녹화 시간에 도달했습니다',
    replay_label: 'screen-recording.json',
    play: '녹화 재생',
    close: '닫기',
    preview_unavailable: '미리보기를 사용할 수 없습니다',
  },
  clarify: {
    title: 'Make This Better AI',
    subtitle: '피드백을 다듬는 중',
    thinking: '생각 중...',
    placeholder: '자세히 적은 뒤 제출',
    send: '보내기',
    submit: '제출',
    send_feedback: '피드백 보내기',
    skip: '건너뛰고 보내기',
    skip_short: '건너뛰기',
    cancel: '취소 — 보내지 않기',
    retry: '재시도',
    error: '질문을 불러오지 못했습니다. 피드백을 그대로 보내세요.',
    expired: '이 피드백 세션은 전송되기 전에 만료되었습니다. 위젯을 닫고 다시 보내 주세요.',
  },
}
